// setup the signature
var canvas;
var context;
var radius = 2;
var signing = false;

function sign(x, y) {
    if(signing) {
        $('.signature').attr('data-signed', 'true');
        context.lineTo(x, y);
        context.stroke();
        context.beginPath();
        // context.arc(e.clientX, e.clientY, radius, 0, Math.PI*2);
        context.arc(x, y, radius, 0, Math.PI*2);
        context.fill();
        context.beginPath();
        context.moveTo(x, y);
    }
}

function engage(x, y) {
    signing = true;
    sign(x, y);
}

function disengage() {
    if($('.signature').length) {
        signing = false;
        context.beginPath();
        $('input[name="signature"]').val(canvas.toDataURL().replace("data:image\/png;base64,",""));
    }
}

if($('.signature').length) {
    canvas = document.getElementById('signature');
    context = canvas.getContext('2d');
    canvas.width = $('.signature').width();
    canvas.height = $('.signature').height();
    context.lineWidth = radius*2;

    if($('.signature input[name="signature"]').val()) {

        var image = new Image();
        image.onload = function() {
            context.drawImage(image, 0, 0);
        }

        image.src = 'data:image/png;base64,'+$('.signature input[name="signature"]').val();
    }

    canvas.addEventListener('mousedown', function(e) {
        e.preventDefault();
        engage(e.offsetX, e.offsetY);
    }, false);
    canvas.addEventListener('mousemove', function(e) {
        e.preventDefault();
        sign(e.offsetX, e.offsetY);
    }, false);
    canvas.addEventListener('mouseup', disengage);

    canvas.addEventListener('touchstart', function(e) {
        var x = (e.changedTouches[0].pageX-$('.signature').offset().left)-2;
        var y = (e.changedTouches[0].pageY-$('.signature').offset().top)-2;
        engage(x, y);
        e.preventDefault();
    }, false);

    canvas.addEventListener('touchmove', function(e) {
        var x = (e.changedTouches[0].pageX-$('.signature').offset().left)-2;
        var y = (e.changedTouches[0].pageY-$('.signature').offset().top)-2;
        sign(x, y);
        e.preventDefault();
    }, false);
    canvas.addEventListener('touchend', disengage);

    $('body').on('click', '.clear-signature', function() {
        context.clearRect( 0 , 0 , canvas.width, canvas.height);
        $('.signature').attr('data-signed', 'false');
        $('input[name="signature"]').val('');
        return false;
    });
}

$(window).on('resize', function() {
    if($('.signature').length) {
        context.clearRect( 0 , 0 , canvas.width, canvas.height);
        $('.signature').attr('data-signed', 'false');
        $('input[name="signature"]').val('');

        canvas.width = $('.signature').width();
        canvas.height = $('.signature').height();
        context.lineWidth = radius*2;
    }
});


$('body').on('change', '.profile .show-secondary', function() {
    var $this = $(this);

    var secondary = ['Divorced', 'Separated'];

    if(secondary.indexOf($this.val()) !== -1) {
        $('.profile .secondary li').removeClass('hidden');
    } else {
        $('.profile .secondary li').addClass('hidden');
    }

    if($this.val() === 'Widowed') {
        $('.profile .widowed').removeClass('hidden');
    } else {
        $('.profile .widowed').addClass('hidden');
    }
});

// profile form
$('body').on('submit', '.profile form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.error').removeClass('error');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            input.addClass('error');
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            showError(data.success ? 'Success' : 'Error', data.message);

            if(data.success) {
                $('.card.continue').removeClass('hidden');
            }
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});
